import React, { useEffect, useState } from "react";
import Breadchrumb from "../components/Breadchrumb";
import { getProducts } from "../data/products";

const Gallery = () => {
  useEffect(() => {
    async function fetchProducts() {
      const productsData = await getProducts();
      setProducts(productsData);
    }
    fetchProducts();
  }, []);

  const [products, setProducts] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);



  return (

    <>
    {/* ---------- HERO SECTION ---------- */}
      <Breadchrumb pageName="Gallery" />
    <section className="gallery">
      <div className="gallery-container">
        <h2>
          Our <span>Gallery</span>
        </h2>
        <p className="gallery-intro">
          A glimpse into our high-quality manufacturing, products, and
          innovation at JB Corporation.
        </p>

        <div className="gallery-grid">
          {products.map((item, index) => (
            <div
              key={index}
              className="gallery-item"
              onClick={() => setSelectedImage(item.imageUrl)}
            >
              <img src={item.imageUrl} alt={`Gallery ${index + 1}`} />
            </div>
          ))}
        </div>

        {/* ---------- LIGHTBOX OVERLAY ---------- */}
        {selectedImage && (
          <div className="lightbox" onClick={() => setSelectedImage(null)}>
            <span className="close-btn" onClick={() => setSelectedImage(null)}>
              &times;
            </span>
            <img src={selectedImage} alt="Enlarged" className="lightbox-img" />
          </div>
        )}
      </div>
    </section>

    </>
  );
};

export default Gallery;
